module.exports = __webpack_public_path__ + "static/media/siddharth-chikmagalur-trip-01.daf9ffe7.png";